import {ActionText} from "components/helpers";
import useAppContext from "lib/hooks/use-app-context";

export default function Default() {
  const {page} = useAppContext();

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="custom-html text-center">
            <ActionText.Content html={page.content} />
          </div>
        </div>
      </div>
    </div>
  );
}
